import { render } from "./distributionReport.vue?vue&type=template&id=93cb8860&scoped=true"
import script from "./distributionReport.vue?vue&type=script&lang=js"
export * from "./distributionReport.vue?vue&type=script&lang=js"

import "./distributionReport.vue?vue&type=style&index=0&id=93cb8860&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cb8860"]])

export default __exports__